import { checkValue } from '../../utils';

const CASE_DATA = 'caseData';

export const getUsername = (state) => {
  let caseDetail = state.cases.get(CASE_DATA);
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  const userDetails = caseDetail && caseDetail.applicant && caseDetail.applicant.user_details;
  return userDetails.username;
};

export const getAddress = (state) => {
  const customerAddress =
    state.cases.get('personalAddress') && state.cases.get('personalAddress').toJS();
  if (customerAddress) {
    const houseNo = customerAddress.hasOwnProperty('house_number') && customerAddress.house_number;
    const addressPrefix =
      customerAddress.hasOwnProperty('address_prefix') && customerAddress.address_prefix;
    const street = customerAddress.hasOwnProperty('street') && customerAddress.street;
    const city = customerAddress.hasOwnProperty('city') && customerAddress.city;
    const postcode = customerAddress.hasOwnProperty('postal_code') && customerAddress.postal_code;
    const county = customerAddress.hasOwnProperty('county') && customerAddress.county;
    const houseName = customerAddress.hasOwnProperty('house_name') && customerAddress.house_name;
    const addressLine2 =
      customerAddress.hasOwnProperty('house_name') && customerAddress.address_line2;
    const organisationName =
      customerAddress.hasOwnProperty('organisation_name') && customerAddress.organisation_name;
    const firstLineAddress = !houseName && organisationName ? organisationName : houseName;
    const secondLineAddress = !street && addressLine2 ? addressLine2 : street;

    return `${checkValue(`${addressPrefix} ${firstLineAddress}`)}${checkValue(
      `${houseNo} ${secondLineAddress}`
    )}${checkValue(city)}${checkValue(county)}${checkValue(postcode).replace(',', '')}`;
  }
  return '';
};

export const business_uuid = (state) => {
  const caseDetail = state.cases ? state.cases.toJS() : '';
  return caseDetail && caseDetail.business_uuid ? caseDetail.business_uuid : '';
};

export const getJointLinkCode = (state) => {
  let caseDetail = state.cases.get(CASE_DATA);
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  return caseDetail && caseDetail.applicant && caseDetail.applicant.joint_link_code
    ? caseDetail.applicant.joint_link_code
    : '';
};

export const getCaseType = (state) => {
  const caseDetail = state.cases ? state.cases.toJS() : '';
  return caseDetail && caseDetail.caseData && caseDetail.caseData.case_subtype
    ? caseDetail.caseData.case_subtype
    : '';
};
